import { connect } from 'react-redux';
import validate from 'validate.js';
import Form from 'react-jsonschema-form';
import { setState } from 'react-jsonschema-form/lib/utils';
import { toErrorList } from 'react-jsonschema-form/lib/validate';
import at from 'lodash/at';
import keys from 'lodash/keys';
import some from 'lodash/some';
import omit from 'lodash/omit';
import { toErrorSchema } from '../../../../utils';
import * as inspectionActions from '../../../inspection/inspection.actions';

validate.validators.anyOfRequired = (
  value,
  options,
  key,
  attributes,
  globalOptions
) => {
  const { constraints } = globalOptions;
  const anyIsValid = some(options, valueKey => {
    const attribute = at(attributes, valueKey)[0];
    const constraintsWithoutAnyOfRequired = omit(
      constraints[valueKey],
      'anyOfRequired'
    );
    const validationResult = validate.single(attribute, {
      ...constraintsWithoutAnyOfRequired,
      presence: true,
    });
    return !validationResult;
  });
  if (!anyIsValid) {
    return 'none of the required fields is valid';
  }
  return null;
};

validate.validators.numericalityLoose = (value, options, key, attributes) => {
  const isValid =
    value === undefined ||
    value === null ||
    value === '' ||
    validate.isNumber(value);
  if (!isValid) {
    return 'is not a valid number or an empty string';
  }
  return null;
};

validate.validators.boolean = (value, options, key, attributes) => {
  const isValidBoolean = validate.isBoolean(value);
  const isValid = options.loose
    ? value === undefined || value === null || isValidBoolean
    : isValidBoolean;
  if (!isValid) {
    return 'is not a valid boolean';
  }
  return null;
};

class SchemaForm extends Form {
  componentWillMount = () => {
    const state = this.doValidate(this.props.formData);
		// console.log('SchemaForm mount props', this.props);
		// console.log('SchemaForm mount state', state);
    setState(this, state, () => {
      this.props.onInit(this.state);
    });
  };

  doValidate = formData => {
    const validationResultLoose =
      validate(formData, this.props.validatorSchema.loose, {
        constraints: this.props.validatorSchema.loose,
      }) || [];
    const validationResultStrict =
      validate(formData, this.props.validatorSchema.strict, {
        constraints: this.props.validatorSchema.strict,
      }) || [];
    const errorSchema = toErrorSchema(validationResultStrict);
    const errors = toErrorList(errorSchema);
    const state = {
      formData,
      errorKeys: keys(validationResultLoose),
      errors,
      errorSchema,
      errorKeysStrict: keys(validationResultStrict),
    };

    return state;
  };

  onChange = (formData, options = { validate: false }) => {
    const state = this.doValidate(formData);
    setState(this, state, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state);
      }
    });
  };
}

const mapStateToProps = state => {
  return {};
};

export default connect(mapStateToProps, inspectionActions)(SchemaForm);



// WEBPACK FOOTER //
// ./src/modules/common/components/form/SchemaForm.js